/* eslint-disable react/prop-types */
import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../src/styles/App.css";
import TicketListPage from "./pages/TicketListPage";
import AppUserProfile from "./assets/js/AppUserProfile";
import RegisterPage from "./pages/RegisterPage";
import HistoryTicketListPage from "./pages/HistoryTicketListPage";
import { NextUIProvider } from "@nextui-org/react";
import CreateTicketPage from "./pages/CreateTicketPage";
import FilterProvider from "./components/layouts/filters/FilterContext";
import RoutePath from "./assets/js/Route";
import PowerBiPage from "./pages/PowerBiPage";
import useTicketStore from "./stores/useTicketStore";
import { useQueryParams } from "./hooks/useQueryParams";
import ExternalLogin from "./pages/external/LoginPage";
import TerminateStaticWebLanding from "./pages/TerminateStaticWebLanding";

const AppInitializer = ({ children }) => {
  const { initFilterByRole } = useTicketStore();
  const queryParams = useQueryParams();

  useEffect(() => {
    const initializeStore = () => {
      const userProfile = AppUserProfile.getData();
      if (userProfile.access_token) {
        const userRole = userProfile["whoami"];

        if (userRole) {
          initFilterByRole(userRole, queryParams);
        }
      }
    };

    initializeStore();
  }, []);

  return children;
};

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const userProfile = AppUserProfile.getData();
      setIsAuthenticated(userProfile.access_token && userProfile.whoami);
    };

    checkAuth();
  }, []);

  return isAuthenticated;
};

function App() {
  const isAuthenticated = useAuth();

  return (
    <NextUIProvider locale="th-TH">
      <FilterProvider>
        <BrowserRouter>
          <AppInitializer>
            <Routes>
              {isAuthenticated ? (
                <>
                  <Route
                    path={RoutePath.Ticket.View}
                    element={<TicketListPage />}
                  />
                  <Route
                    path={RoutePath.Ticket.Create}
                    element={<CreateTicketPage />}
                  />
                  <Route
                    path="/history-ticket-list"
                    element={<HistoryTicketListPage />}
                  />
                  <Route path={RoutePath.PowerBi} element={<PowerBiPage />} />
                  <Route
                    path="*"
                    element={<Navigate to={RoutePath.Ticket.View} replace />}
                  />
                </>
              ) : (
                <>
                  <Route
                    path={RoutePath.External.Login}
                    element={<ExternalLogin />}
                  />
                  <Route
                    path={RoutePath.Auth.Register}
                    element={<RegisterPage />}
                  />
                  <Route path="*" element={<TerminateStaticWebLanding />} />
                </>
              )}
            </Routes>
          </AppInitializer>
        </BrowserRouter>
      </FilterProvider>
    </NextUIProvider>
  );
}

export default App;
